module.exports = __webpack_public_path__ + "img/TESL-magic-book.02018d1b.jpg";